import { createContext } from 'react';
import type { AuthContextValue } from './types';

/**
 * The auth context object. Lives in its own module to satisfy
 * react-refresh/only-export-components: a file that exports a React component
 * (AuthProvider) cannot also export non-component values like a context or
 * a hook without breaking Fast Refresh.
 *
 * Consumers should not import this directly. Use the `useAuth` hook from
 * `./use-auth` instead, which handles the null check.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);
